import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {FlagGoodsBrandCd, FlagGoodsCd, FlagGoodsTmember, FlagGoodsTp} from "@COMPONENTS/common/flag/Mobile";
import * as style from "@COMPONENTS/style/productlist/departurepopupM";
import IconButton from "@FRAMEWORK/ui/mobile/button/IconButton";
import {Flex} from "@FRAMEWORK/ui/mobile/layout";
import {RedText} from "@FRAMEWORK/ui/mobile/text";
import useGlobalGoodsLive from "@QUERIES/bff/global/useGlobalGoodsLive";
import useBannerContents from "@QUERIES/essential/banner/useBannerContents";
import useBannerGoodsDeal from "@QUERIES/essential/banner/useBannerGoodsDeal";
import useGoodsBannerPick from "@QUERIES/portal/useGoodsBannerPick";
import {GoodsDetail} from "@QUERIES/prdt/goods/useGoodsDetail";
import {format} from "@yb/utils";
import dayjs from "dayjs";
import {useRouter} from "next/router";
import {
	BannerContents,
	BannerYellowLive,
	BannerYellowPangDeal,
	BannerYellowPick,
} from "@COMPONENTS/product/common/popup/mobile/EventListPopup/EventListBanner";

interface Props {
	goodsCd: string;
	productDetail: GoodsDetail;
	handleShare: () => void;
}

const EventListInfoComponent = ({goodsCd, productDetail, handleShare}: Props) => {
	const router = useRouter();
	const {menu, dspSid} = router.query;

	const bannerContentsFetch = useBannerContents("GOST");
	const bannerContents = bannerContentsFetch.data?.body || [];

	const bannerDealFetch = useBannerGoodsDeal(goodsCd);
	const bannerDeal = bannerDealFetch.data?.body;

	const bannerLiveFetch = useGlobalGoodsLive(goodsCd);
	const bannerLive = bannerLiveFetch.data?.body;

	const bannerPickFetch = useGoodsBannerPick(goodsCd);
	const bannerPick = bannerPickFetch.data?.body;

	if (!menu && !dspSid) return <></>;

	return (
		<>
			<style.ContentTop>
				<style.SummaryInfo>
					<style.ScoreText>
						<style.StarImg />
						<em>{productDetail.rvwAvgScore > 0 ? productDetail.rvwAvgScore : `-`}</em>/ 5
					</style.ScoreText>
					<IconButton type="button" icon="share" onClick={() => handleShare()}>
						<span>공유하기</span>
					</IconButton>
				</style.SummaryInfo>
				<Flex gap="3">
					<FlagGoodsCd goodsCd={productDetail.goodsCd} />
					<FlagGoodsTp goodsTp={productDetail.goodsTp} />
					<FlagGoodsBrandCd goodsBrandCd={productDetail.goodsBrandCd} />
					<FlagGoodsTmember goodsTmember={productDetail.goodsTmember} />
				</Flex>
				<style.TopTitle>{productDetail.goodsNm}</style.TopTitle>
				<style.TopPriceBox>
					<Flex align="center" gap="8">
						최저가
						<RedText>
							<em>{format.koKRFormatNumber(productDetail.minPrice)}</em>원
						</RedText>
						<style.TopPriceDate>({dayjs(productDetail.minPriceDate).format("YYYY.MM.DD")})</style.TopPriceDate>
					</Flex>
					<Flex align="center" gap="8">
						최고가
						<RedText>
							<em>{format.koKRFormatNumber(productDetail.maxPrice)}</em>원
						</RedText>
						<style.TopPriceDate>({dayjs(productDetail.maxPriceDate).format("YYYY.MM.DD")})</style.TopPriceDate>
					</Flex>
				</style.TopPriceBox>
			</style.ContentTop>
			{/* 배너 */}
			{(bannerContents.length > 0 || bannerDeal || bannerLive) && (
				<style.EventBannerWrap>
					{bannerContents.length > 0 && <BannerContents bannerContents={bannerContents} />}
					{bannerPick && <BannerYellowPick pick={bannerPick} />}
					{bannerDeal && <BannerYellowPangDeal deal={bannerDeal} />}
					{bannerLive && <BannerYellowLive live={bannerLive} />}
				</style.EventBannerWrap>
			)}
		</>
	);
};

const EventListInfo = (props: Props) => (
	<ErrorBoundary logMsg="DeparetureDayPopup Info Error">
		<EventListInfoComponent {...props} />
	</ErrorBoundary>
);

export default EventListInfo;
